import { useNavigate } from 'react-router-dom';
import { homepageArticles } from '@/mocks/articles';

export default function ArticleSection() {
  const navigate = useNavigate();

  return (
    <section id="articles" className="relative w-full py-24 md:py-36 px-6 md:px-10 bg-background-200/70">
      <div className="max-w-7xl mx-auto">
        <div className="mb-14">
          <span className="inline-block px-4 py-1.5 rounded-full border border-foreground-300 text-xs font-medium text-foreground-500 uppercase tracking-wider mb-6">
            Buying Guides
          </span>
          <h2 className="font-heading text-3xl md:text-5xl font-extrabold text-foreground-800 leading-tight">
            Real Shopping
            <br />
            Guides &amp; Reviews
          </h2>
        </div>

        <div className="columns-1 md:columns-2 lg:columns-3 gap-5 md:gap-6">
          {homepageArticles.map((article) => (
            <div
              key={article.id}
              className="break-inside-avoid mb-5 md:mb-6 rounded-xl bg-background-50 border border-background-200/60 p-5 md:p-6 hover:border-accent-300 transition-all duration-200"
            >
              <div className="flex items-center gap-3 mb-4">
                <div className={`w-10 h-10 rounded-full ${article.accent} flex items-center justify-center text-xs font-bold text-foreground-700 flex-shrink-0`}>
                  {article.author.split(' ').map(n => n[0]).join('')}
                </div>
                <div>
                  <p className="text-sm font-semibold text-foreground-800">{article.author}</p>
                  <p className="text-xs text-foreground-400">@{article.date}</p>
                </div>
              </div>

              <h3 className="font-heading font-semibold text-base md:text-lg text-foreground-800 mb-3 leading-snug">
                {article.title}
              </h3>

              <div className="relative pl-4 border-l-2 border-accent-300">
                <p className="text-sm text-foreground-600 leading-relaxed">
                  <span className="text-accent-500 text-xl font-serif leading-none">&ldquo;</span>
                  {article.excerpt}
                  <span className="text-accent-500 text-xl font-serif leading-none">&rdquo;</span>
                </p>
              </div>

              <button
                onClick={() => {
                  navigate(article.slug);
                  window.scrollTo({ top: 0, behavior: 'smooth' });
                }}
                className="mt-4 inline-flex items-center gap-1.5 text-sm font-semibold text-accent-600 hover:text-accent-800 transition-colors duration-200 whitespace-nowrap cursor-pointer"
              >
                Read more
                <i className="ri-arrow-right-line w-4 h-4 flex items-center justify-center"></i>
              </button>
            </div>
          ))}
        </div>

        <div className="text-center mt-12">
          <button
            onClick={() => {
              navigate('/hipobuy-spreadsheet-guide');
              window.scrollTo({ top: 0, behavior: 'smooth' });
            }}
            className="inline-flex items-center gap-2 px-8 py-3.5 rounded-full text-sm font-semibold bg-foreground-800 text-background-50 hover:bg-foreground-950 transition-all duration-200 whitespace-nowrap cursor-pointer"
          >
            View All Guides
            <i className="ri-arrow-right-line w-4 h-4 flex items-center justify-center"></i>
          </button>
        </div>
      </div>
    </section>
  );
}